export type UsersTab = 'visitors' | 'fields' | 'emails' | 'api' | 'settings';

/** Вкладка раздела из адреса; «Посетители» — по умолчанию, в адресе не пишется. */
export function isUsersTab(value: unknown): value is Exclude<UsersTab, 'visitors'> {
  return value === 'fields' || value === 'emails' || value === 'api' || value === 'settings';
}
